import React, {useEffect, useState} from 'react';
import './App.scss';
import MainSectionComponent from "./pages/main/MainSection";
import {BrowserRouter, Route, Routes} from "react-router-dom";
import OrderDetailsSection from "./sections/OrderDetailsSection";
import OrderMainFoodSectionComponent from "./sections/OrderMainFoodSectionComponent";
import OrderMainSectionComponent from "./sections/orderMainSection/OrderMainSectionComponent";
import ProfileComponent from "./sections/profileSection/ProfileComponent";
import ProfileSectionChangePassword from "./sections/profileSection/components/ProfileSectionChangePassword";
import HelpWithOrderComponent from "./sections/helpWithOrder/HelpWithOrderComponent";
import CodesPage from "./pages/codes/CodesPage";
import ContactUsComponent from "./sections/contactUsSection/ContactUsComponent";
import HowItWorksSectionComponent from "./sections/howItWorksSection/HowItWorksSectionComponent";
import {useDispatch, useSelector} from "react-redux";
import { UseAuth } from "./api/useAuth";
import {setUserValue} from "./reducers/userReducer";
import CartPage from "./pages/cart/CartPage";
import OrderMainAcceptedSectionComponent
  from "./sections/orderMainSection/components/acceptOrder/OrderMainAcceptedSectionComponent";
import { useGeolocated } from "react-geolocated";
import { SetUserCoords } from "./api/useUser";
import {I18nextProvider} from "react-i18next";
import i18n from "./localization/i18n";
import PrivacyPolicy from "./pages/policy/privacyPolicy/PrivacyPolicy";

function App() {
  const user = useSelector((state: any) => state.user);
  const dispatch = useDispatch();
  const { language } = i18n;
  const [loading, setLoading] = useState(false);
  const { coords, isGeolocationAvailable, isGeolocationEnabled } =
    useGeolocated({
      positionOptions: {
        enableHighAccuracy: false,
      },
      userDecisionTimeout: 5000,
    });
  const userLocalCoords = JSON.parse(localStorage.getItem("coords") as string);
  
  useEffect(() => {
    UseAuth(language).then((response: any) => {
      //console.log("login response: ", response);
      if (response && response.status === 200) {
        dispatch (setUserValue ({key: "id", value: response.result.user.id}));
        dispatch (setUserValue ({key: "name", value: response.result.user.name}));
        dispatch (setUserValue ({key: "email", value: response.result.user.email}));
        dispatch (setUserValue ({key: "phoneNr", value: response.result.user.mobile}));
        dispatch (setUserValue ({key: "isAuth", value: true}));
        dispatch (setUserValue ({key: "cartCount", value: response.result.user?.cartCount}));
        dispatch (setUserValue ({key: "qrCodeCount", value: response.result.user?.qrCodeCount}));
	      dispatch(setUserValue({ key: "address", value: response.result.user?.address }));
      }
      else {
        dispatch(setUserValue({ key: "id", value: "" }));
        dispatch(setUserValue({ key: "name", value: "" }));
        dispatch(setUserValue({ key: "email", value: "" }));
        dispatch(setUserValue({ key: "phoneNr", value: "" }));
        dispatch(setUserValue({ key: "isAuth", value: false }));
        dispatch(setUserValue({ key: "cartCount", value: 0 }));
        dispatch(setUserValue({ key: "qrCodeCount", value: 0 }));
	      dispatch(setUserValue({ key: "address", value: 0 }));
      }
    });
  }, [dispatch]);
  
  useEffect(() => {
    const userLocalCoords = JSON.parse(localStorage.getItem("coords") || "null");
    
    if (coords && isGeolocationAvailable && isGeolocationEnabled) {
      const saveCoordsToLocal = (latitude: number, longitude: number) => {
        localStorage.setItem("coords", JSON.stringify({ latitude, longitude }));
      };
      
      const saveCoordsToServer = async (latitude: number, longitude: number) => {
        if (user && user.id) {
          SetUserCoords(user.id, latitude, longitude).then((response: any) => {
            console.log("Set server with new coordinates:", response);
            saveCoordsToLocal(latitude, longitude);
            dispatch(setUserValue({ key: "address", value: response?.address }));
          });
        } else {
          saveCoordsToLocal(latitude, longitude);
        }
      };
      
      /* if (userLocalCoords) {
        const { latitude, longitude } = userLocalCoords;
        if (latitude !== coords.latitude || longitude !== coords.longitude) {
          saveCoordsToServer(coords.latitude, coords.longitude).then (r  => console.log("saveCoordsToServer 1"));
        }
      } else {
        saveCoordsToServer(coords.latitude, coords.longitude).then (r  => console.log("saveCoordsToServer 2"));
      } */
      
      if (coords.latitude && coords.longitude) {
        saveCoordsToServer(coords.latitude, coords.longitude).then (r  => console.log("saveCoordsToServer 2"));
      }
      
    }
  }, [coords, isGeolocationAvailable, isGeolocationEnabled, user]);

  return (
    <I18nextProvider i18n={i18n}>
      <BrowserRouter>
          <Routes>
              <Route path="/" element={<MainSectionComponent />}/>
              {/*<Route path="/login" element={<LoginSectionComponent />}/>*/}
              {/*<Route path="/how-it-works" element={<MainSectionComponent />}/>*/}
              <Route path="/mobile-app" element={<MainSectionComponent />}/>
              <Route path="/follow-us" element={<MainSectionComponent />}/>
              <Route path="/food/" element={<OrderMainFoodSectionComponent />}>
                  <Route path="/food/:category" element={<OrderMainFoodSectionComponent />} />
              </Route>
              <Route path="/food/:category/:details" element={<OrderDetailsSection />} />
              <Route path="/food/:category/:details/:order" element={<OrderMainSectionComponent />} />
              <Route path="/cart/:details" element={<OrderMainAcceptedSectionComponent />} />
              <Route path="/cart" element={<CartPage />} />
                {/* <Route path="/cart/:details/accept-order" element={<CartPage />} /> */}
              {/* </Route> */}
              <Route path="/help-with-order" element={<HelpWithOrderComponent/>}>
                  <Route path="/help-with-order/:faq" element={<HelpWithOrderComponent/>}/>
              </Route>
              <Route path="/profile" element={<ProfileComponent/>}/>
              <Route path="/profile/:change-password" element={<ProfileSectionChangePassword/>}/>
              <Route path="/my-codes" element={<CodesPage/>}>
                  <Route path="/my-codes/:category" element={<CodesPage/>}/>
              </Route>
              <Route path="/my-codes/:category/:subcategory" element={<CodesPage/>}/>
              <Route path="/contact-us" element={<ContactUsComponent/>}/>
              <Route path="/how-it-works" element={<HowItWorksSectionComponent/>}/>
              <Route path="/privacy-policy" element={<PrivacyPolicy/>}/>
          </Routes>
      </BrowserRouter>
    </I18nextProvider>
  );
}

export default App;
